export default "__VITE_ASSET__61062afc__"